import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/app/hooks";
import { fetchAnalyticsMetricsAsync } from "../../../redux/features/analyticsSlice";
import ColoredBorderSummaryCard from "../../../components/cards/ColoredBorderSummaryCard";
import MixedChart from "../../../components/charts/MixedChart";

const MetricsAnalytics = () => {
  const { loading, metricsAnalytics } = useAppSelector(
    (state) => state.analytics
  );
  const dispatch = useAppDispatch();

  const xLabels = ["Last 24h", "Last 7d", "Last 30d"];

  // Series for transactions (bar chart)
  const transactionSeries = [
    {
      name: "Transactions",
      type: "bar" as const,
      data: [
        metricsAnalytics?.totalTransactions?.last24h,
        metricsAnalytics?.totalTransactions?.last7d,
        metricsAnalytics?.totalTransactions?.last30d,
      ],
      color: "#60a5fa",
    },
  ];

  // Series for revenue (line chart)
  const revenueSeries = [
    {
      name: "Revenue",
      type: "line" as const,
      data: [
        metricsAnalytics?.totalRevenue?.last24h,
        metricsAnalytics?.totalRevenue?.last7d,
        metricsAnalytics?.totalRevenue?.last30d,
      ],
      color: "#fbbf24",
    },
  ];

  useEffect(() => {
    dispatch(fetchAnalyticsMetricsAsync());
  }, [dispatch]);


  return (
    <div className="flex gap-10 flex-col p-6">
      <p className="text-2xl">Analytics</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-5 gap-4">
        <ColoredBorderSummaryCard
          title="Total Users"
          value={metricsAnalytics?.totalUsers}
          borderColor="border-t-black"
          loading={loading}
          loadingColor="text-black"
        />
        <ColoredBorderSummaryCard
          title="Total Vendors"
          value={metricsAnalytics?.totalVendors}
          borderColor="border-t-blue-500"
          loading={loading}
          loadingColor="text-blue-500"
        />
        <ColoredBorderSummaryCard
          title="Active Contracts"
          value={metricsAnalytics?.activeContracts}
          borderColor="border-t-green-500"
          loading={loading}
          loadingColor="text-green-500"
        />
        <ColoredBorderSummaryCard
          title="Pending Contracts"
          value={metricsAnalytics?.pendingContracts}
          borderColor="border-t-yellow-500"
          loading={loading}
          loadingColor="text-yellow-500"
        />
        <ColoredBorderSummaryCard
          title="Pending Orders"
          value={metricsAnalytics?.pendingOrders}
          borderColor="border-t-orange-500"
          loading={loading}
          loadingColor="text-orange-500"
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-4">
        <MixedChart
          title="Transactions"
          xLabels={xLabels}
          series={transactionSeries}
        />
        <MixedChart title="Revenue" xLabels={xLabels} series={revenueSeries} />
      </div>
    </div>
  );
};

export default MetricsAnalytics;
